// src/App.tsx

import React from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import "./App.css";

import Layout from "./compoonents/Layout/Layout";
import ProtectedRoute from "./compoonents/ProtectedRoute";
import PublicRoute from "./compoonents/PublicRoute";

import LoginPage from "./pages/LoginPage/LoginPage";
import Dashboard from "./pages/Dashboard/Dashboard";
import CustomersPage from "./pages/CustomersPage/CustomersPage";
import CustomerDetailsPage from "./pages/CustomerDetailsPage/CustomerDetailsPage";
import QuoteRequestPage from "./pages/QuoteRequestPage/QuoteRequestPage";
import TrackingMgtPage from "./pages/TrackingMgtPage/TrackingMgtPage";
import TrackingDetailsPage from "./pages/TrackingDetailsPage/TrackingDetailsPage";
import PurchaseOrdersPage from "./pages/ProductsPage/ProductsPage";
import PurchaseOrderDetailsPage from "./pages/PurchaseOrderDetailsPage/PurchaseOrderDetailsPage";
import TransactionPage from "./pages/TransactionPage/TransactionPage";
import SupportTicketPage from "./pages/SupportTicketPag/SupportTicketPage";
import AuditMgtPage from "./pages/AuditMgtPage/AuditMgtPage";
import UserManagementPage from "./pages/UserManagementPage/UserManagementPage";
import SettingsPage from "./pages/SettingsPage/SettingsPage";
import ShipmentPage from "./pages/ShipmentPage/ShipmentPage";
import FXPage from "./pages/FXPage/FXPage";
import ShipmentDetailsPage from "./pages/ShipmentDetailsPage/ShipmentDetailsPage";
import ProductDetailsPage from "./pages/ProductDetailsPage/ProductDetailsPage";
import { Provider } from "react-redux";
import AdminProfileUpload from "./pages/ImageUploadPage/ImageUploadPage";
import VendorsPage from "./pages/VendorsPage/VendorsPage";
import VendorDetailsPage from './pages/VendorDetailsPage/VendorDetailsPage';
import ShopWithLinkPage from "./pages/ShopWithLinkPage/ShopWithLinkPage";
import FoodingOrderDetailsPage from "./pages/FoodingOrderDetailsPage/FoodingOrderDetailsPage";
import NaijaShopPage from "./pages/NaijaShopPage/NaijaShopPage";
import AmazonPage from "./pages/AmazonPage/AmazonPage";
import AmazonOrderDetailsPage from "./pages/AmazonOrderDetailsPage/AmazonOrderDetailsPage";
   

function App() {
  return ( 
    <BrowserRouter>
      <Routes> 
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<LoginPage />} />
        </Route>
 
        <Route element={<ProtectedRoute />}>
          <Route
            path="/"
            element={
              <Layout pageTitle="Dashboard">
                <Dashboard />
              </Layout>
            }
          />
          <Route
            path="/dashboard"
            element={
              <Layout pageTitle="Dashboard">
                <Dashboard />
              </Layout>
            }
          />

          <Route
            path="/customers"
            element={
              <Layout pageTitle="Customers">
                <CustomersPage />
              </Layout>
            }
          />
          <Route
            path="/customers/:customerId"
            element={
              <Layout pageTitle="Customer Details">
                <CustomerDetailsPage />
              </Layout>
            }
          />

          <Route
            path="/quote-request"
            element={
              <Layout pageTitle="Quote Request">
                <QuoteRequestPage />
              </Layout>
            }
          />
          <Route
            path="/tracking"
            element={
              <Layout pageTitle="Tracking Management">
                <TrackingMgtPage />
              </Layout>
            }
          />
          <Route
            path="/tracking/:trackingId"
            element={
              <Layout pageTitle="Tracking Details">
                <TrackingDetailsPage />
              </Layout>
            }
          />

          <Route
            path="/purchase-orders"
            element={
              <Layout pageTitle="Fooding">
                <PurchaseOrdersPage />
              </Layout>
            }
          />
          <Route
            path="/purchase-orders/:orderId"
            element={
              <Layout pageTitle="Purchase Order Details">
                <PurchaseOrderDetailsPage />
              </Layout>
            }
          />
          <Route
            path="/fooding-orders/:orderId"
            element={
              <Layout pageTitle="Fooding Order Details">
                <FoodingOrderDetailsPage />
              </Layout>
            }
          />

          <Route
            path="/shop-with-link"
            element={
              <Layout pageTitle="Shop With Link">
                <ShopWithLinkPage />
              </Layout>
            }
          />
          <Route
            path="/naija-shop"
            element={
              <Layout pageTitle="Naija Shop">
                <NaijaShopPage />
              </Layout>
            }
          />
          <Route
            path="/amazon"
            element={
              <Layout pageTitle="Amazon">
                <AmazonPage />
              </Layout>
            }
          />
          <Route
            path="/amazon/:cartId"
            element={
              <Layout pageTitle="Amazon Order Details">
                <AmazonOrderDetailsPage />
              </Layout>
            }
          />
          <Route
            path="/shop-with-link/:orderId"
            element={
              <Layout pageTitle="Shop With Link Details">
                <PurchaseOrderDetailsPage />
              </Layout>
            }
          />

          <Route
            path="/product-details/:productId"
            element={
              <Layout pageTitle="Purchase Order Details">
                <ProductDetailsPage />
              </Layout>
            }
          />

          <Route
            path="/transactions"
            element={
              <Layout pageTitle="Transaction">
                <TransactionPage />
              </Layout>
            }
          />
          <Route
            path="/support"
            element={
              <Layout pageTitle="Support Ticket">
                <SupportTicketPage />
              </Layout>
            }
          />
          <Route
            path="/audit"
            element={
              <Layout pageTitle="Audit Management">
                <AuditMgtPage />
              </Layout>
            }
          />
          <Route
            path="/user-management"
            element={
              <Layout pageTitle="User Management">
                <UserManagementPage />
              </Layout>
            }
          />
          <Route
            path="/shipments"
            element={
              <Layout pageTitle="Shipment">
                <ShipmentPage />
              </Layout>
            }
          />
          <Route
            path="/shipments/:shipmentId"
            element={
              <Layout pageTitle="Shipment Details">
                <ShipmentDetailsPage />
              </Layout>
            }
          />
          <Route
            path="/fx"
            element={
              <Layout pageTitle="FX">
                <FXPage />
              </Layout>
            }
          />
          <Route
            path="/settings"
            element={
              <Layout pageTitle="Settings">
                <SettingsPage />
              </Layout>
            }
          />
          <Route
            path="/vendors"
            element={
              <Layout pageTitle="Vendors">
                <VendorsPage />
              </Layout>
            }
          />
          <Route
            path="/vendors/:vendorId"
            element={
              <Layout pageTitle="Vendor Details">
                <VendorDetailsPage />
              </Layout>
            }
          />
          <Route path="/exchange-rate" element={<Navigate to="/fx" replace />} />

          <Route
            path="/profile-upload"
            element={
              <Layout pageTitle="Profile">
                <AdminProfileUpload />
              </Layout>
            }
          />
        </Route>

        

        {/* It's good practice to have a fallback route for unmatched paths */}
        <Route path="*" element={<h1>404: Page Not Found</h1>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
